$(document).ready(function(){

    // Clone Navigation
    var $navigationWrapper = $(".nav-wrapper");
    var $navigationBtn = $navigationWrapper.find('#nav-btn');

    $navigationBtn.on("click", function(e){
        e.preventDefault();
        $navigationWrapper.toggleClass('open');
        $('#nav-icon4').toggleClass('open');
        $("#menu-text").text(function(i, text){
            return text === "MENU" ? "CLOSE" : "MENU";
        })
    });
    
}); 